import { useUser } from "@accurx/concierge/hooks/data/useUser";
import { PatientSmsItem } from "@accurx/concierge/schemas/ConversationItemSchema";
import { getPreviewSummaryNote } from "domains/inbox/util/getPreviewSummaryNote";

import { PreviewSummaryTemplate } from "../../PreviewSummaryTemplate";

export type MessagePatientSmsProps = {
    conversationItem: PatientSmsItem;
};

export const MessagePatientSms = ({
    conversationItem,
}: MessagePatientSmsProps) => {
    const userId = conversationItem.createdBy.id;
    const participant = useUser({ userId });

    return (
        <PreviewSummaryTemplate
            note={getPreviewSummaryNote(participant)}
            messageSummary={conversationItem.body}
        />
    );
};
